<div class="main-wrapper">
  <div class="header-main">
    <app-header [showTopbar]="true" [showinner]="true"></app-header>
  </div>
  <div class="content-main">
    <div class="sidebar">
      <app-sidebar [sideMenu]="sideMenu" [facebookUrl]="facebookUrl" [instagramUrl]="instagramUrl"></app-sidebar>
    </div>
    <div class="main-panel">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </div>
</div>

